export default {
  "industry_011000": "011000 - Growing of vegetables, melons, flowers and other non-perennial crops",
  "industry_012000": "012000 - Growing of fruits, drug and beverage crops and other perennial crops",
  "industry_013000": "013000 - Plant propagation",
  "industry_014100": "014100 - Raising of livestock",
  "industry_014200": "014200 - Raising of poultry and eggs",
  "industry_014900": "014900 - Raising of other animals",
  "industry_015000": "015000 - Mixed farming",
  "industry_016000": "016000 - Support activities to agriculture and post-harvest crop activities",
  "industry_017000": "017000 - Hunting, trapping and related service activities",
  "industry_020000": "020000 - Forestry activities",
  "industry_031000": "031000 - Fishing",
  "industry_032000": "032000 - Aquaculture",
  "industry_050000": "050000 - Mining of coal and lignite",
  "industry_060000": "060000 - Extraction of crude petroleum and natural gas",
  "industry_070000": "070000 - Mining of metal ores",
  "industry_080000": "080000 - Quarrying and other mining of non-metal ores",
  "industry_090000": "090000 - Mining support service activities",
  "industry_101100": "101100 - Rendering of lard and tallow",
  "industry_101200": "101200 - Slaughtering",
  "industry_101300": "101300 - Meat preserving",
  "industry_101400": "101400 - Manufacture and processing of slaughtering by-products (excl. leather tanning and dressing)",
  "industry_102000": "102000 - Processing and preserving of fish, crustaceans and molluscs",
  "industry_103000": "103000 - Processing and preserving of fruit and vegetables",
  "industry_104000": "104000 - Manufacture of plant and animal oils and fats",
  "industry_105000": "105000 - Manufacture of dairy products",
  "industry_106101": "106101 - Manufacture of bean curd",
  "industry_106199": "106199 - Manufacture of grain mill products n.e.c.",
  "industry_106200": "106200 - Manufacture of starches and starch products",
  "industry_107100": "107100 - Manufacture of bakery products",
  "industry_107200": "107200 - Manufacture of sugar",
  "industry_107300": "107300 - Manufacture of cocoa, chocolate and confectionery",
  "industry_107400": "107400 - Manufacture of noodles and similar farinaceous products",
  "industry_107500": "107500 - Manufacture of prepared meals and dishes",
  "industry_107901": "107901 - Ice manufacture (excl. dry ice)",
  "industry_107902": "107902 - Manufacture of tea products",
  "industry_107903": "107903 - Production of coffee products",
  "industry_107904": "107904 - Manufacture of spices, sauces and condiments",
  "industry_107999": "107999 - Manufacture of other miscellaneous food products n.e.c.",
  "industry_108000": "108000 - Manufacture of prepared animal feeds",
  "industry_110100": "110100 - Manufacture of beer",
  "industry_110200": "110200 - Manufacture of alcoholic beverage other than beer",
  "industry_110300": "110300 - Manufacture of soft drinks; production of mineral waters and other non-alcoholic drinks",
  "industry_120000": "120000 - Manufacture of tobacco products",
  "industry_131101": "131101 - Texturising",
  "industry_131102": "131102 - Spinning, cotton",
  "industry_131103": "131103 - Spinning, wool",
  "industry_131104": "131104 - Spinning, synthetic fibre",
  "industry_131199": "131199 - Spinning n.e.c.",
  "industry_131201": "131201 - Weaving, cotton",
  "industry_131202": "131202 - Weaving, wool",
  "industry_131203": "131203 - Weaving, silk",
  "industry_131204": "131204 - Synthetic fibres weaving",
  "industry_131299": "131299 - Weaving, blend fibre and other textiles n.e.c.",
  "industry_131301": "131301 - Textile stencilling and printing of fabrics",
  "industry_131302": "131302 - Textile stencilling and printing of garment",
  "industry_131303": "131303 - Bleaching and dyeing of yarn",
  "industry_131304": "131304 - Bleaching and dyeing of woven fabrics",
  "industry_131305": "131305 - Bleaching and dyeing of knitted fabrics",
  "industry_131306": "131306 - Bleaching and dyeing of garment",
  "industry_131307": "131307 - Garment washing (excl. laundering)",
  "industry_131399": "131399 - Textile finishing n.e.c.",
  "industry_139101": "139101 - Knitting or crocheting of fabrics, cotton",
  "industry_139102": "139102 - Knitting or crocheting of fabrics, wool",
  "industry_139199": "139199 - Knitting or crocheting of fabrics n.e.c.",
  "industry_139201": "139201 - Manufacture of canvas products",
  "industry_139202": "139202 - Manufacture of bed articles",
  "industry_139203": "139203 - Manufacture of sails and flags",
  "industry_139204": "139204 - Button holing, seaming and pleating",
  "industry_139205": "139205 - Curtain or drapery cutting and sewing",
  "industry_139206": "139206 - Manufacture of silkscreen for printing (excl. textile stencilling and printing)",
  "industry_139207": "139207 - Ribbon and tape cutting (excl. weaving of label and narrow fabrics)",
  "industry_139299": "139299 - Manufacture of made-up textile articles (except apparel) n.e.c.",
  "industry_139300": "139300 - Manufacture of carpets and rugs",
  "industry_139401": "139401 - Manufacture of fishing nets",
  "industry_139402": "139402 - Manufacture of rope",
  "industry_139403": "139403 - Manufacture of shoe laces",
  "industry_139404": "139404 - Manufacture of twine",
  "industry_139500": "139500 - Weaving, labels (excl. laces, ribbon/tape, ropes, twines and cordage)",
  "industry_139600": "139600 - Manufacture of embroidery",
  "industry_139700": "139700 - Manufacture of laminated cloth",
  "industry_139900": "139900 - Manufacture of other miscellaneous textiles n.e.c.",
  "industry_141101": "141101 - Manufacture of outer garments (excl. leather garment, raincoat, knitwear from yarn)",
  "industry_141102": "141102 - Tailoring (excl. custom tailoring without workshop)",
  "industry_141103": "141103 - Manufacture of raincoats",
  "industry_141104": "141104 - Manufacture of under garments and night garments",
  "industry_141105": "141105 - Manufacture of leather garments",
  "industry_141199": "141199 - Manufacture of garments and clothing n.e.c.",
  "industry_141901": "141901 - Manufacture of gloves (excl. plastic and rubber gloves)",
  "industry_141902": "141902 - Manufacture of headgear (excl. straw headgear, plastic and metal and fibreglass helmet)",
  "industry_141903": "141903 - Manufacture of waist belts",
  "industry_141904": "141904 - Manufacture of neckwear",
  "industry_141999": "141999 - Manufacture of other miscellaneous wearing apparel n.e.c.",
  "industry_142000": "142000 - Manufacture of articles of fur",
  "industry_143100": "143100 - Manufacture of knitted and crocheted hosiery (incl. all materials)",
  "industry_143200": "143200 - Manufacture of knitted and crocheted outerwear (excl. garment not knitted, raincoat, leather garment)",
  "industry_143300": "143300 - Manufacture of knitted and crocheted underwear",
  "industry_151100": "151100 - Tanning and dressing of leather; dressing and dyeing of fur",
  "industry_151200": "151200 - Manufacture of luggage and handbags (excl. plastic shopping bags)",
  "industry_151901": "151901 - Manufacture of wrist watchbands, leather or non-metallic",
  "industry_151999": "151999 - Manufacture of miscellaneous products of leather and leather substitutes n.e.c. (excl. footwear and wearing apparel)",
  "industry_152000": "152000 - Manufacture of footwear",
  "industry_161000": "161000 - Sawmilling and planing of wood",
  "industry_162100": "162100 - Manufacture of veneer sheets and wood-based panels",
  "industry_162200": "162200 - Manufacture of wooden containers (excl. chest of camphor woods)",
  "industry_162901": "162901 - Manufacture of wooden domestic utensils, jewellery boxes or other articles",
  "industry_162902": "162902 - Manufacture of rattan materials and articles",
  "industry_162903": "162903 - Manufacture of bamboo materials and articles",
  "industry_162904": "162904 - Manufacture of plaiting materials and straw wares",
  "industry_162905": "162905 - Manufacture of cork materials and articles",
  "industry_170100": "170100 - Manufacture of pulp, paper and paperboard",
  "industry_170201": "170201 - Manufacture of paper boxes",
  "industry_170202": "170202 - Manufacture of paper bags",
  "industry_170901": "170901 - Manufacture of joss paper",
  "industry_170902": "170902 - Manufacture of paper cones",
  "industry_170903": "170903 - Manufacture of paper lantern",
  "industry_170904": "170904 - Manufacture of paper stationery",
  "industry_170905": "170905 - Manufacture of toilet paper, tissue paper and napkins",
  "industry_170906": "170906 - Manufacture of wallpaper",
  "industry_170999": "170999 - Manufacture of miscellaneous articles of paper and paperboard n.e.c.",
  "industry_181100": "181100 - Printing",
  "industry_181201": "181201 - Book binding",
  "industry_181202": "181202 - Photo-engraving, composition and typesetting (excl. design)",
  "industry_181299": "181299 - Printing allied industries n.e.c.",
  "industry_182000": "182000 - Reproduction of recorded media",
  "industry_190100": "190100 - Manufacture of asphalt",
  "industry_190200": "190200 - Petroleum refineries",
  "industry_190900": "190900 - Manufacture of coke and refined petroleum products n.e.c.",
  "industry_201101": "201101 - Manufacture of chemicals",
  "industry_201102": "201102 - Manufacture of dyes",
  "industry_201103": "201103 - Mixing of pigments",
  "industry_201200": "201200 - Manufacture of fertilisers and nitrogen compounds",
  "industry_201300": "201300 - Manufacture of plastics and synthetic rubber in primary forms",
  "industry_202100": "202100 - Manufacture of pesticides and other agrochemical products",
  "industry_202200": "202200 - Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  "industry_202301": "202301 - Manufacture of cosmetics, perfumes and toilet preparations",
  "industry_202302": "202302 - Manufacture of detergent and soaps",
  "industry_202901": "202901 - Manufacture of camphor products",
  "industry_202902": "202902 - Manufacture of joss sticks",
  "industry_202903": "202903 - Manufacture of mosquito sticks",
  "industry_202904": "202904 - Manufacture of glue",
  "industry_202905": "202905 - Manufacture of explosives",
  "industry_202999": "202999 - Manufacture of other miscellaneous chemical products n.e.c.",
  "industry_203000": "203000 - Manufacture of man-made fibres",
  "industry_211100": "211100 - Manufacture of Chinese herbal and drug medicine",
  "industry_211200": "211200 - Manufacture of western medicine, diagnostic and therapeutic medicaments, and medical and nursing preparations",
  "industry_212000": "212000 - Manufacture of veterinary pharmaceuticals",
  "industry_221100": "221100 - Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres",
  "industry_221900": "221900 - Manufacture of other rubber products",
  "industry_222100": "222100 - Manufacture of plastic flowers and foliage (excl. metal flowers, other artificial flowers)",
  "industry_222200": "222200 - Manufacture of plastic domestic utensils",
  "industry_222300": "222300 - Manufacture of plastic bags (excl. handbags)",
  "industry_222400": "222400 - Manufacture of plastic cases and parts",
  "industry_222901": "222901 - Plastic stencilling",
  "industry_222902": "222902 - Manufacture of foam rubber articles and sponge goods",
  "industry_222999": "222999 - Manufacture of miscellaneous plastics products n.e.c. (except furniture, toys, sports goods and stationery)",
  "industry_231000": "231000 - Manufacture of glass, glass fibre and glass products",
  "industry_239100": "239100 - Manufacture of refractory and structural clay products",
  "industry_239200": "239200 - Manufacture of pottery, china and earthenware",
  "industry_239300": "239300 - Manufacture of cement, lime and plaster",
  "industry_239400": "239400 - Manufacture of articles of concrete, cement and plaster",
  "industry_239500": "239500 - Cutting, shaping and finishing of marble and stone",
  "industry_239900": "239900 - Manufacture of other non-metallic mineral products n.e.c.",
  "industry_241000": "241000 - Manufacture of basic iron and steel (excl. casting)",
  "industry_242100": "242100 - Manufacture of basic copper",
  "industry_242200": "242200 - Manufacture of basic aluminium",
  "industry_242300": "242300 - Precious metal refinery (excl. goldsmithing and silversmithing)",
  "industry_242900": "242900 - Manufacture of basic non-ferrous metals n.e.c. (excl. casting)",
  "industry_243100": "243100 - Casting of iron and steel",
  "industry_243201": "243201 - Copper foundries",
  "industry_243202": "243202 - Aluminium casting",
  "industry_243299": "243299 - Casting of non-ferrous metals n.e.c.",
  "industry_251101": "251101 - Manufacture of metal windows, doors and gates",
  "industry_251199": "251199 - Manufacture of structural products of metal n.e.c.",
  "industry_251200": "251200 - Manufacture of tanks, reservoirs and containers of metal",
  "industry_251300": "251300 - Manufacture of steam generators (except central heating hot water boilers)",
  "industry_259100": "259100 - Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
  "industry_259201": "259201 - Buffing, polishing and electroplating",
  "industry_259299": "259299 - Treatment and coating of metals n.e.c.",
  "industry_259301": "259301 - Manufacture of nails, screws and hinges",
  "industry_259302": "259302 - Manufacture of cutlery",
  "industry_259303": "259303 - Manufacture of hand tools and metal hardware",
  "industry_259901": "259901 - Manufacture of cans and domestic utensils of metal",
  "industry_259999": "259999 - Manufacture of other miscellaneous fabricated metal products n.e.c.",
  "industry_261100": "261100 - Manufacture of electronic parts and components for computer and telecommunications equipment",
  "industry_261900": "261900 - Manufacture of electronic parts and components n.e.c.",
  "industry_262000": "262000 - Manufacture of computers and peripheral equipment",
  "industry_263000": "263000 - Manufacture of communication equipment",
  "industry_264000": "264000 - Manufacture of audio and video equipment",
  "industry_265100": "265100 - Manufacture of measuring, testing, navigating and control equipment",
  "industry_265201": "265201 - Manufacture of mechanical watches, watch movements, mechanical clocks and clock movements",
  "industry_265202": "265202 - Manufacture of electronic watches, watch movements, electronic clocks and clock movements",
  "industry_265203": "265203 - Manufacture of cases and parts for watches and clocks n.e.c.",
  "industry_266000": "266000 - Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  "industry_267100": "267100 - Manufacture of photographic equipment (optical and digital)",
  "industry_267200": "267200 - Manufacture of other optical instruments and equipment (except ophthalmic goods) n.e.c.",
  "industry_268000": "268000 - Manufacture of magnetic and optical media",
  "industry_271000": "271000 - Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus",
  "industry_272000": "272000 - Manufacture of dry batteries and accumulators",
  "industry_273100": "273100 - Manufacture of electric wire, fibre optic cables and other cables",
  "industry_273200": "273200 - Manufacture of wiring devices",
  "industry_274000": "274000 - Manufacture of electric and non-electrical lighting equipment",
  "industry_275000": "275000 - Manufacture of domestic electric appliances",
  "industry_279000": "279000 - Manufacture of other electrical equipment",
  "industry_281100": "281100 - Manufacture of engines and turbines (except aircraft, motor vehicle and motorcycle engines)",
  "industry_281200": "281200 - Manufacture of fluid power equipment",
  "industry_281300": "281300 - Manufacture of other pumps, compressors, taps and valves",
  "industry_281400": "281400 - Manufacture of bearings, gears, gearing and driving elements",
  "industry_281500": "281500 - Manufacture of ovens and furnaces",
  "industry_281600": "281600 - Manufacture of lifting, loading and unloading equipment",
  "industry_281700": "281700 - Manufacture of office machinery and equipment (except computers and peripheral equipment)",
  "industry_281800": "281800 - Manufacture of power-driven hand tools",
  "industry_281900": "281900 - Manufacture of other general-purpose machinery",
  "industry_282100": "282100 - Manufacture of agricultural and forestry machinery",
  "industry_282200": "282200 - Manufacture of metal-forming machinery and machine tools",
  "industry_282300": "282300 - Manufacture of machinery for metallurgy",
  "industry_282400": "282400 - Manufacture of machinery for mining, quarrying and construction",
  "industry_282500": "282500 - Manufacture of machinery for food, beverage and tobacco processing",
  "industry_282600": "282600 - Manufacture of machinery for textile, apparel and leather production",
  "industry_282900": "282900 - Manufacture of other special-purpose machinery",
  "industry_290000": "290000 - Body assembly of motor vehicles",
  "industry_301100": "301100 - Building of ships and floating structures",
  "industry_301200": "301200 - Building of pleasure and sporting boats",
  "industry_302000": "302000 - Manufacture of railway locomotives and rolling stock",
  "industry_303000": "303000 - Aircraft assembly and manufacture of related machinery",
  "industry_309100": "309100 - Manufacture of motorcycles",
  "industry_309200": "309200 - Manufacture of bicycles and invalid carriages",
  "industry_309900": "309900 - Manufacture of other transport equipment n.e.c.",
  "industry_310101": "310101 - Manufacture of wooden furniture and fixtures",
  "industry_310102": "310102 - Manufacture of rattan furniture",
  "industry_310200": "310200 - Manufacture of metal furniture and fixtures",
  "industry_310900": "310900 - Manufacture of furniture and fixtures of other materials",
  "industry_321101": "321101 - Cutting and setting of precious stones",
  "industry_321102": "321102 - Goldsmithing and silversmithing",
  "industry_321103": "321103 - Manufacture of jewellery (excl. artificial pearls, imitation jewellery) and precious metal accessories",
  "industry_321200": "321200 - Manufacture of imitation jewellery and related articles",
  "industry_322000": "322000 - Manufacture of musical instruments",
  "industry_323000": "323000 - Manufacture of sports goods",
  "industry_324100": "324100 - Manufacture of wooden toys",
  "industry_324200": "324200 - Manufacture of rubber toys",
  "industry_324300": "324300 - Manufacture of plastic toys",
  "industry_324400": "324400 - Manufacture of metal toys",
  "industry_324500": "324500 - Manufacture of electronic games and toys",
  "industry_324900": "324900 - Manufacture of games and toys n.e.c.",
  "industry_325100": "325100 - Manufacture of spectacles and ophthalmic products",
  "industry_325200": "325200 - Manufacture of dentures (incl. dental laboratories)",
  "industry_325900": "325900 - Manufacture of medical and dental instruments and supplies n.e.c.",
  "industry_329100": "329100 - Manufacture of candles",
  "industry_329200": "329200 - Manufacture of wigs and related products",
  "industry_329301": "329301 - Manufacture of buttons",
  "industry_329302": "329302 - Manufacture of slide fasteners",
  "industry_329400": "329400 - Manufacture of umbrellas and related products",
  "industry_329500": "329500 - Manufacture of stationery articles (except paper stationery)",
  "industry_329600": "329600 - Manufacture of advertising displays (except electric, neon and illuminated signs)",
  "industry_329900": "329900 - Manufacture of miscellaneous products n.e.c.",
  "industry_331100": "331100 - Repair of fabricated metal products",
  "industry_331200": "331200 - Repair of machinery",
  "industry_331300": "331300 - Repair of electronic and optical equipment",
  "industry_331400": "331400 - Repair of electrical equipment",
  "industry_331500": "331500 - Repair of air, water and rail transport equipment",
  "industry_331900": "331900 - Repair of other non-household equipment",
  "industry_332000": "332000 - Installation of industrial machinery and equipment",
  "industry_351000": "351000 - Electric power generation, transmission and distribution",
  "industry_352000": "352000 - Manufacture and distribution of gas",
  "industry_359000": "359000 - Supply of air-conditioning, steam and similar products through mains systems",
  "industry_360000": "360000 - Water collection, treatment and supply",
  "industry_370000": "370000 - Sewerage",
  "industry_381100": "381100 - Collection of non-hazardous waste",
  "industry_381200": "381200 - Collection of hazardous waste",
  "industry_382100": "382100 - Treatment and disposal of non-hazardous waste",
  "industry_382200": "382200 - Treatment and disposal of hazardous waste",
  "industry_383100": "383100 - Motor vehicle breaking",
  "industry_383900": "383900 - Recovery of materials n.e.c.",
  "industry_390000": "390000 - Remediation activities and other waste management services",
  "industry_411000": "411000 - Erection of architectural superstructures",
  "industry_412000": "412000 - Structural steel framework erection",
  "industry_419100": "419100 - Structural alteration and addition works",
  "industry_419200": "419200 - Erection of minor architectural superstructures",
  "industry_419300": "419300 - Erection of temporary structures",
  "industry_419900": "419900 - Combined and other miscellaneous new building construction works",
  "industry_421000": "421000 - Construction of civil engineering projects",
  "industry_422000": "422000 - Miscellaneous civil engineering works",
  "industry_431100": "431100 - Demolition",
  "industry_431201": "431201 - Site formation and clearance",
  "industry_431202": "431202 - Foundation works",
  "industry_431203": "431203 - Site investigation",
  "industry_431204": "431204 - Excavation work",
  "industry_431299": "431299 - Combined and other site preparation works",
  "industry_432101": "432101 - Electrical wiring and fitting",
  "industry_432102": "432102 - Electrical fitting with water plumbing",
  "industry_432103": "432103 - Fire alarm and fire fighting equipment, installation and maintenance",
  "industry_432104": "432104 - Anti-burglar system, installation and maintenance",
  "industry_432105": "432105 - Intercommunication system, installation and maintenance",
  "industry_432106": "432106 - Telecommunications equipment, installation and maintenance",
  "industry_432199": "432199 - Combined and other installation and maintenance of electrical and mechanical equipment",
  "industry_432201": "432201 - Air-conditioning and ventilation system, installation and maintenance",
  "industry_432202": "432202 - Water plumbing and drain laying",
  "industry_432203": "432203 - Water well drilling",
  "industry_432204": "432204 - Gas fitting, installation and maintenance",
  "industry_432299": "432299 - Combined and other ventilation, gas and water fitting, installation and maintenance",
  "industry_432901": "432901 - Lift and escalator, installation and maintenance",
  "industry_432999": "432999 - Miscellaneous construction installation and maintenance n.e.c.",
  "industry_439101": "439101 - Interior fitting, decoration and repairs for buildings",
  "industry_439102": "439102 - Exterior renovation and repairs for buildings",
  "industry_439199": "439199 - Combination of interior fitting, decoration and exterior renovation and repairs for buildings",
  "industry_439901": "439901 - Concrete work",
  "industry_439902": "439902 - Steel bending (incl. welding)",
  "industry_439903": "439903 - Bamboo scaffolding",
  "industry_439904": "439904 - Metal scaffolding",
  "industry_439905": "439905 - Carpentry",
  "industry_439906": "439906 - Masonry",
  "industry_439907": "439907 - Sheet metal work",
  "industry_439908": "439908 - Roofing and water proofing",
  "industry_439911": "439911 - Brick laying, tile setting and plastering",
  "industry_439912": "439912 - Floor laying (excl. setting floor tiles)",
  "industry_439913": "439913 - Window installation and glass glazing",
  "industry_439914": "439914 - Painting",
  "industry_439915": "439915 - Crane operation",
  "industry_439916": "439916 - Carpet fitting, upholstery and wallpapering",
  "industry_439917": "439917 - Fencing, railing and related metal structure installation",
  "industry_439918": "439918 - Ornamentation fitting",
  "industry_439999": "439999 - Miscellaneous finishing and specialised construction works n.e.c.",
  "industry_451100": "451100 - Export trading on a fee or contract basis",
  "industry_451201": "451201 - Export trading of livestock and poultry",
  "industry_451202": "451202 - Export trading of cotton, textile fibre and yarn",
  "industry_451203": "451203 - Export trading of leather (incl. imitation leather and other plastic sheetings)",
  "industry_451204": "451204 - Export trading of rubber",
  "industry_451205": "451205 - Export trading of wood and rattan",
  "industry_451206": "451206 - Export trading of fresh flowers and plants",
  "industry_451207": "451207 - Export trading of pet animals (incl. aquarium fish)",
  "industry_451299": "451299 - Export trading of agricultural products and live animals n.e.c.",
  "industry_451301": "451301 - Export trading of canned foods",
  "industry_451302": "451302 - Export trading of confectioneries and biscuits",
  "industry_451303": "451303 - Export trading of dairy products",
  "industry_451304": "451304 - Export trading of edible oils",
  "industry_451305": "451305 - Export trading of nuts, seeds and dried beans",
  "industry_451306": "451306 - Export trading of eggs",
  "industry_451307": "451307 - Export trading of feeds for animals and pets",
  "industry_451308": "451308 - Export trading of fish and other sea products, dried or preserved",
  "industry_451311": "451311 - Export trading of fish and other sea products, fresh or frozen",
  "industry_451312": "451312 - Export trading of fruits and vegetables, fresh",
  "industry_451313": "451313 - Export trading of meat, fresh or frozen (incl. poultry and meat of wild animals)",
  "industry_451314": "451314 - Export trading of noodles and rice sticks",
  "industry_451315": "451315 - Export trading of rice",
  "industry_451316": "451316 - Export trading of sugar and flour",
  "industry_451317": "451317 - Export trading of tea, coffee and cocoa",
  "industry_451318": "451318 - Export trading of meat, roasted, dried or preserved",
  "industry_451321": "451321 - Export trading of preserved provisions and spices",
  "industry_451322": "451322 - Export trading of tobacco, cigarettes and cigars",
  "industry_451323": "451323 - Export trading of alcoholic drinks",
  "industry_451324": "451324 - Export trading of groceries of general provisions",
  "industry_451399": "451399 - Export trading of specialised food n.e.c.",
  "industry_451401": "451401 - Export trading of footwear and shoe accessories",
  "industry_451402": "451402 - Export trading of fabrics",
  "industry_451403": "451403 - Export trading of tailoring accessories and trimming materials",
  "industry_451404": "451404 - Export trading of wearing apparel",
  "industry_451405": "451405 - Export trading of embroidery and drawn works",
  "industry_451406": "451406 - Export trading of household linen, drapery, carpets, rugs and allied products",
  "industry_451407": "451407 - Export trading of rope, cord and netting appliances",
  "industry_451408": "451408 - Export trading of umbrellas",
  "industry_451411": "451411 - Export trading of luggage cases, handbags and similar articles of leather or leather substitutes",
  "industry_451421": "451421 - Export trading of antiques and works of art and craft",
  "industry_451422": "451422 - Export trading of bamboo and cane products (excl. furniture and fixtures)",
  "industry_451423": "451423 - Export trading of books, periodicals and newspapers",
  "industry_451424": "451424 - Export trading of china, earthenware and glassware",
  "industry_451425": "451425 - Export trading of Chinese drugs and herbs",
  "industry_451426": "451426 - Export trading of cooking and kitchen utensils, other than electrical",
  "industry_451427": "451427 - Export trading of toilet preparations and cleaning materials",
  "industry_451428": "451428 - Export trading of drugs and pharmaceuticals (excl. Chinese drugs and herbs)",
  "industry_451431": "451431 - Export trading of cosmetics and perfumes",
  "industry_451432": "451432 - Export trading of jewellery and precious metal accessories",
  "industry_451433": "451433 - Export trading of imitation jewellery and related articles",
  "industry_451434": "451434 - Export trading of hardware and metalware",
  "industry_451435": "451435 - Export trading of spectacles and optical supplies",
  "industry_451436": "451436 - Export trading of photographic equipment and supplies",
  "industry_451437": "451437 - Export trading of recorded audio and video tapes, CDs, DVDs and similar media",
  "industry_451438": "451438 - Export trading of sacks and bags (excl. handbags and travelling bags)",
  "industry_451441": "451441 - Export trading of stationery",
  "industry_451442": "451442 - Export trading of musical instruments",
  "industry_451443": "451443 - Export trading of sports goods",
  "industry_451444": "451444 - Export trading of toys",
  "industry_451445": "451445 - Export trading of computer games",
  "industry_451446": "451446 - Export trading of watches and clocks",
  "industry_451447": "451447 - Export trading of paper products",
  "industry_451448": "451448 - Export trading of Chinese religious articles",
  "industry_451451": "451451 - Export trading of plastic products (incl. decorative ornaments and flowers)",
  "industry_451452": "451452 - Export trading of electrical goods (excl. machinery, office and telecommunications equipment and appliances)",
  "industry_451499": "451499 - Export trading of household goods n.e.c.",
  "industry_451501": "451501 - Export trading of motor vehicles",
  "industry_451502": "451502 - Export trading of motorcycles",
  "industry_451503": "451503 - Export trading of parts and accessories of motor vehicles and motorcycles",
  "industry_451599": "451599 - Export trading of other transport equipment (except motor vehicles and motorcycles)",
  "industry_451601": "451601 - Export trading of computers and computer peripheral equipment",
  "industry_451602": "451602 - Export trading of computer software",
  "industry_451611": "451611 - Export trading of telecommunications equipment",
  "industry_451612": "451612 - Export trading of blank audio and video tapes, diskettes, CDs and DVDs",
  "industry_451613": "451613 - Export trading of electronic parts",
  "industry_451621": "451621 - Export trading of agricultural machinery, equipment and supplies",
  "industry_451631": "451631 - Export trading of scientific and professional instruments (excl. medical and dental instruments)",
  "industry_451632": "451632 - Export trading of sewing machines and parts (incl. stands)",
  "industry_451633": "451633 - Export trading of medical, health and hospital equipment and supplies",
  "industry_451634": "451634 - Export trading of office appliances and equipment (excl. computers, furniture and fixtures)",
  "industry_451635": "451635 - Export trading of cases and other parts for watches and clocks",
  "industry_451699": "451699 - Export trading of machinery and equipment n.e.c. (except furniture)",
  "industry_451701": "451701 - Export trading of firewood, charcoal, coke and similar fuels",
  "industry_451702": "451702 - Export trading of oil fuels and lubricants",
  "industry_451703": "451703 - Export trading of petroleum products (kerosene and L.P. gas)",
  "industry_451711": "451711 - Export trading of metals and metal ores",
  "industry_451721": "451721 - Export trading of construction materials, hardware and plumbing equipment and supplies",
  "industry_451731": "451731 - Export trading of furniture and fixtures",
  "industry_451741": "451741 - Export trading of chemicals and allied products",
  "industry_451742": "451742 - Export trading of paints and varnishes",
  "industry_451743": "451743 - Export trading of paper for industrial use and printing",
  "industry_451744": "451744 - Export trading of waste and scrap",
  "industry_451799": "451799 - Export trading of other specialised products n.e.c.",
  "industry_451900": "451900 - Non-specialised export trading",
  "industry_452100": "452100 - Import for wholesale on a fee or contract basis",
  "industry_452201": "452201 - Import for wholesale of livestock and poultry",
  "industry_452202": "452202 - Import for wholesale of cotton, textile fibre and yarn",
  "industry_452203": "452203 - Import for wholesale of leather (incl. imitation leather and other plastic sheetings)",
  "industry_452204": "452204 - Import for wholesale of rubber",
  "industry_452205": "452205 - Import for wholesale of wood and rattan",
  "industry_452206": "452206 - Import for wholesale of fresh flowers and plants",
  "industry_452207": "452207 - Import for wholesale of pet animals (incl. aquarium fish)",
  "industry_452299": "452299 - Import for wholesale of agricultural products and live animals n.e.c.",
  "industry_452301": "452301 - Import for wholesale of canned foods",
  "industry_452302": "452302 - Import for wholesale of confectioneries and biscuits",
  "industry_452303": "452303 - Import for wholesale of dairy products",
  "industry_452304": "452304 - Import for wholesale of edible oils",
  "industry_452305": "452305 - Import for wholesale of nuts, seeds and dried beans",
  "industry_452306": "452306 - Import for wholesale of eggs",
  "industry_452307": "452307 - Import for wholesale of feeds for animals and pets",
  "industry_452308": "452308 - Import for wholesale of fish and other sea products, dried or preserved",
  "industry_452311": "452311 - Import for wholesale of fish and other sea products, fresh or frozen",
  "industry_452312": "452312 - Import for wholesale of fruits and vegetables, fresh",
  "industry_452313": "452313 - Import for wholesale of meat, fresh or frozen (incl. poultry and meat of wild animals)",
  "industry_452314": "452314 - Import for wholesale of noodles and rice sticks",
  "industry_452315": "452315 - Import for wholesale of rice",
  "industry_452316": "452316 - Import for wholesale of sugar and flour",
  "industry_452317": "452317 - Import for wholesale of tea, coffee and cocoa",
  "industry_452318": "452318 - Import for wholesale of meat, roasted, dried or preserved",
  "industry_452321": "452321 - Import for wholesale of preserved provisions and spices",
  "industry_452322": "452322 - Import for wholesale of tobacco, cigarettes and cigars",
  "industry_452323": "452323 - Import for wholesale of alcoholic drinks",
  "industry_452324": "452324 - Import for wholesale of groceries of general provisions",
  "industry_452399": "452399 - Import for wholesale of specialised food n.e.c.",
  "industry_452401": "452401 - Import for wholesale of footwear and shoe accessories",
  "industry_452402": "452402 - Import for wholesale of fabrics",
  "industry_452403": "452403 - Import for wholesale of tailoring accessories and trimming materials",
  "industry_452404": "452404 - Import for wholesale of wearing apparel",
  "industry_452405": "452405 - Import for wholesale of embroidery and drawn works",
  "industry_452406": "452406 - Import for wholesale of household linen, drapery, carpets, rugs and allied products",
  "industry_452407": "452407 - Import for wholesale of rope, cord and netting appliances",
  "industry_452408": "452408 - Import for wholesale of umbrellas",
  "industry_452411": "452411 - Import for wholesale of luggage cases, handbags and similar articles of leather or leather substitutes",
  "industry_452421": "452421 - Import for wholesale of antiques and works of art and craft",
  "industry_452422": "452422 - Import for wholesale of bamboo and cane products (excl. furniture and fixtures)",
  "industry_452423": "452423 - Import for wholesale of books, periodicals and newspapers",
  "industry_452424": "452424 - Import for wholesale of china, earthenware and glassware",
  "industry_452425": "452425 - Import for wholesale of Chinese drugs and herbs",
  "industry_452426": "452426 - Import for wholesale of cooking and kitchen utensils, other than electrical",
  "industry_452427": "452427 - Import for wholesale of toilet preparations and cleaning materials",
  "industry_452428": "452428 - Import for wholesale of drugs and pharmaceuticals (excl. Chinese drugs and herbs)",
  "industry_452431": "452431 - Import for wholesale of cosmetics and perfumes",
  "industry_452432": "452432 - Import for wholesale of jewellery and precious metal accessories",
  "industry_452433": "452433 - Import for wholesale of imitation jewellery and related articles",
  "industry_452434": "452434 - Import for wholesale of hardware and metalware",
  "industry_452435": "452435 - Import for wholesale of spectacles and optical supplies",
  "industry_452436": "452436 - Import for wholesale of photographic equipment and supplies",
  "industry_452437": "452437 - Import for wholesale of recorded audio and video tapes, CDs, DVDs and similar media",
  "industry_452438": "452438 - Import for wholesale of sacks and bags (excl. handbags and travelling bags)",
  "industry_452441": "452441 - Import for wholesale of stationery",
  "industry_452442": "452442 - Import for wholesale of musical instruments",
  "industry_452443": "452443 - Import for wholesale of sports goods",
  "industry_452444": "452444 - Import for wholesale of toys",
  "industry_452445": "452445 - Import for wholesale of computer games",
  "industry_452446": "452446 - Import for wholesale of watches and clocks",
  "industry_452447": "452447 - Import for wholesale of paper products",
  "industry_452448": "452448 - Import for wholesale of Chinese religious articles",
  "industry_452451": "452451 - Import for wholesale of plastic products (incl. decorative ornaments and flowers)",
  "industry_452452": "452452 - Import for wholesale of electrical goods (excl. machinery, office and telecommunications equipment and appliances)",
  "industry_452499": "452499 - Import for wholesale of household goods n.e.c.",
  "industry_452501": "452501 - Import for wholesale of motor vehicles",
  "industry_452502": "452502 - Import for wholesale of motorcycles",
  "industry_452503": "452503 - Import for wholesale of parts and accessories of motor vehicles and motorcycles",
  "industry_452599": "452599 - Import for wholesale of other transport equipment (except motor vehicles and motorcycles)",
  "industry_452601": "452601 - Import for wholesale of computers and computer peripheral equipment",
  "industry_452602": "452602 - Import for wholesale of computer software",
  "industry_452611": "452611 - Import for wholesale of telecommunications equipment and parts",
  "industry_452612": "452612 - Import for wholesale of blank audio and video tapes, diskettes, CDs and DVDs",
  "industry_452613": "452613 - Import for wholesale of electronic parts",
  "industry_452621": "452621 - Import for wholesale of agricultural machinery, equipment and supplies",
  "industry_452631": "452631 - Import for wholesale of scientific and professional instruments (excl. medical and dental instruments)",
  "industry_452632": "452632 - Import for wholesale of sewing machines and parts (incl. stands)",
  "industry_452633": "452633 - Import for wholesale of medical, health and hospital equipment and supplies",
  "industry_452634": "452634 - Import for wholesale of office appliances and equipment (excl. computers, furniture and fixtures)",
  "industry_452635": "452635 - Import for wholesale of cases and other parts for watches and clocks",
  "industry_452699": "452699 - Import for wholesale of machinery and equipment n.e.c. (except furniture)",
  "industry_452701": "452701 - Import for wholesale of firewood, charcoal, coke and similar fuels",
  "industry_452702": "452702 - Import for wholesale of oil fuels and lubricants",
  "industry_452703": "452703 - Import for wholesale of petroleum products (kerosene and L.P. gas)",
  "industry_452711": "452711 - Import for wholesale of metals and metal ores",
  "industry_452721": "452721 - Import for wholesale of construction materials, hardware and plumbing equipment and supplies",
  "industry_452731": "452731 - Import for wholesale of furniture and fixtures",
  "industry_452741": "452741 - Import for wholesale of chemicals and allied products",
  "industry_452742": "452742 - Import for wholesale of paints and varnishes",
  "industry_452743": "452743 - Import for wholesale of paper for industrial use and printing",
  "industry_452744": "452744 - Import for wholesale of waste and scrap",
  "industry_452799": "452799 - Import for wholesale of other specialised products n.e.c.",
  "industry_452900": "452900 - Non-specialised import for wholesale",
  "industry_460100": "460100 - Brokers and agents for wholesale (incl. auctioneers)",
  "industry_460201": "460201 - Wholesale of livestock and poultry",
  "industry_460202": "460202 - Wholesale of cotton, textile fibre and yarn",
  "industry_460203": "460203 - Wholesale of leather (incl. imitation leather and other plastic sheetings)",
  "industry_460204": "460204 - Wholesale of rubber",
  "industry_460205": "460205 - Wholesale of wood and rattan",
  "industry_460206": "460206 - Wholesale of fresh flowers and plants",
  "industry_460207": "460207 - Wholesale of pet animals (incl. aquarium fish)",
  "industry_460299": "460299 - Wholesale of agricultural products and live animals n.e.c.",
  "industry_460301": "460301 - Wholesale of canned foods",
  "industry_460302": "460302 - Wholesale of confectioneries and biscuits",
  "industry_460303": "460303 - Wholesale of dairy products",
  "industry_460304": "460304 - Wholesale of edible oils",
  "industry_460305": "460305 - Wholesale of nuts, seeds and dried beans",
  "industry_460306": "460306 - Wholesale of eggs",
  "industry_460307": "460307 - Wholesale of feeds for animals and pets",
  "industry_460308": "460308 - Wholesale of fish and other sea products, dried or preserved",
  "industry_460311": "460311 - Wholesale of fish and other sea products, fresh or frozen",
  "industry_460312": "460312 - Wholesale of fruits and vegetables, fresh",
  "industry_460313": "460313 - Wholesale of meat, fresh or frozen (incl. poultry and meat of wild animals)",
  "industry_460314": "460314 - Wholesale of noodles",
  "industry_460315": "460315 - Wholesale of rice",
  "industry_460316": "460316 - Wholesale of sugar and flour",
  "industry_460317": "460317 - Wholesale of tea, coffee and cocoa",
  "industry_460318": "460318 - Wholesale of meat, roasted, dried or preserved",
  "industry_460321": "460321 - Wholesale of preserved provisions and spices",
  "industry_460322": "460322 - Wholesale of tobacco, cigarettes and cigars",
  "industry_460323": "460323 - Wholesale of alcoholic drinks",
  "industry_460324": "460324 - Wholesale of groceries of general provisions",
  "industry_460399": "460399 - Wholesale of specialised food n.e.c.",
  "industry_460401": "460401 - Wholesale of footwear and shoe accessories",
  "industry_460402": "460402 - Wholesale of fabrics",
  "industry_460403": "460403 - Wholesale of tailoring accessories and trimming materials",
  "industry_460404": "460404 - Wholesale of wearing apparel",
  "industry_460405": "460405 - Wholesale of embroidery and drawn works",
  "industry_460406": "460406 - Wholesale of household linen, drapery, carpets, rugs and allied products",
  "industry_460407": "460407 - Wholesale of rope, cord and netting appliances",
  "industry_460408": "460408 - Wholesale of umbrellas",
  "industry_460411": "460411 - Wholesale of luggage cases, handbags and similar articles of leather or leather substitutes",
  "industry_460421": "460421 - Wholesale of antiques and works of art and craft",
  "industry_460422": "460422 - Wholesale of bamboo and cane products (excl. furniture and fixtures)",
  "industry_460423": "460423 - Wholesale of books, periodicals and newspapers",
  "industry_460424": "460424 - Wholesale of china, earthenware and glassware",
  "industry_460425": "460425 - Wholesale of Chinese drugs and herbs",
  "industry_460426": "460426 - Wholesale of cooking and kitchen utensils, other than electrical",
  "industry_460427": "460427 - Wholesale of toilet preparations and cleaning materials",
  "industry_460428": "460428 - Wholesale of drugs and pharmaceuticals (excl. Chinese drugs and herbs)",
  "industry_460431": "460431 - Wholesale of cosmetics and perfumes",
  "industry_460432": "460432 - Wholesale of jewellery and precious metal accessories",
  "industry_460433": "460433 - Wholesale of imitation jewellery and related articles",
  "industry_460434": "460434 - Wholesale of hardware and metalware",
  "industry_460435": "460435 - Wholesale of spectacles and optical supplies",
  "industry_460436": "460436 - Wholesale of photographic equipment and supplies",
  "industry_460437": "460437 - Wholesale of recorded audio and video tapes, CDs, DVDs and similar media",
  "industry_460438": "460438 - Wholesale of sacks and bags (excl. handbags and travelling bags)",
  "industry_460441": "460441 - Wholesale of stationery",
  "industry_460442": "460442 - Wholesale of musical instruments",
  "industry_460443": "460443 - Wholesale of sports goods",
  "industry_460444": "460444 - Wholesale of toys",
  "industry_460445": "460445 - Wholesale of computer games",
  "industry_460446": "460446 - Wholesale of watches and clocks",
  "industry_460447": "460447 - Wholesale of paper products",
  "industry_460448": "460448 - Wholesale of Chinese religious articles",
  "industry_460451": "460451 - Wholesale of plastic products (incl. decorative ornaments and flowers)",
  "industry_460452": "460452 - Wholesale of electrical goods (excl. machinery, office and telecommunications equipment and appliances)",
  "industry_460499": "460499 - Wholesale of household goods n.e.c.",
  "industry_460501": "460501 - Wholesale of motor vehicles",
  "industry_460502": "460502 - Wholesale of motorcycles",
  "industry_460503": "460503 - Wholesale of parts and accessories of motor vehicles and motorcycles",
  "industry_460599": "460599 - Wholesale of other transport equipment (except motor vehicles and motorcycles)",
  "industry_460601": "460601 - Wholesale of computers and computer peripheral equipment",
  "industry_460602": "460602 - Wholesale of computer software",
  "industry_460611": "460611 - Wholesale of telecommunications equipment and parts",
  "industry_460612": "460612 - Wholesale of blank audio and video tapes, diskettes, CDs and DVDs",
  "industry_460613": "460613 - Wholesale of electronic parts",
  "industry_460621": "460621 - Wholesale of agricultural machinery, equipment and supplies",
  "industry_460631": "460631 - Wholesale of scientific and professional instruments (excl. medical and dental instruments)",
  "industry_460632": "460632 - Wholesale of sewing machines and parts (incl. stands)",
  "industry_460633": "460633 - Wholesale of medical, health and hospital equipment and supplies",
  "industry_460634": "460634 - Wholesale of office appliances and equipment (excl. computers, furniture and fixtures)",
  "industry_460635": "460635 - Wholesale of cases and other parts for watches and clocks",
  "industry_460699": "460699 - Wholesale of machinery and equipment n.e.c. (except furniture)",
  "industry_460701": "460701 - Wholesale of firewood, charcoal, coke and similar fuels",
  "industry_460702": "460702 - Wholesale of oil fuels and lubricants",
  "industry_460703": "460703 - Wholesale of petroleum products (kerosene and L.P. gas)",
  "industry_460711": "460711 - Wholesale of metals and metal ores",
  "industry_460721": "460721 - Wholesale of construction materials, hardware and plumbing equipment and supplies",
  "industry_460731": "460731 - Wholesale of furniture and fixtures",
  "industry_460741": "460741 - Wholesale of chemicals and allied products",
  "industry_460742": "460742 - Wholesale of paints and varnishes",
  "industry_460743": "460743 - Wholesale of paper for industrial use and printing",
  "industry_460744": "460744 - Wholesale of waste and scrap",
  "industry_460799": "460799 - Wholesale of other specialised products n.e.c.",
  "industry_460900": "460900 - Non-specialised wholesale",
  "industry_471101": "471101 - Supermarkets",
  "industry_471102": "471102 - Convenience stores",
  "industry_471103": "471103 - Grocery stores of Chinese provisions",
  "industry_471104": "471104 - Grocery stores of general provisions",
  "industry_471901": "471901 - Department stores",
  "industry_471999": "471999 - Other retail sale of general merchandise",
  "industry_472101": "472101 - Retail sale of bread and pastry",
  "industry_472102": "472102 - Retail sale of confectioneries and biscuits",
  "industry_472103": "472103 - Retail sale of fish and other sea products, dried or preserved",
  "industry_472104": "472104 - Retail sale of fish, other sea products and meat, fresh or frozen",
  "industry_472105": "472105 - Retail sale of fruits and vegetables, fresh",
  "industry_472106": "472106 - Retail sale of noodles and rice sticks",
  "industry_472107": "472107 - Retail sale of preserved provisions and spices (incl. dried or preserved fruits and vegetables)",
  "industry_472108": "472108 - Retail sale of rice",
  "industry_472111": "472111 - Retail sale of meat, roasted, dried or preserved",
  "industry_472112": "472112 - Retail sale of tea",
  "industry_472113": "472113 - Retail sale of bean curd and bean products",
  "industry_472114": "472114 - Retail sale of eggs",
  "industry_472199": "472199 - Specialised food retail stores, without seats provided n.e.c.",
  "industry_472201": "472201 - Retail sale of alcoholic beverages in specialised stores",
  "industry_472202": "472202 - Retail sale of non-alcoholic beverages in specialised stores",
  "industry_472299": "472299 - Retail sale of beverages (incl. alcoholic and non-alcoholic)",
  "industry_472300": "472300 - Retail sale of tobacco products in specialised stores",
  "industry_473100": "473100 - Petrol filling stations",
  "industry_473200": "473200 - Retail sale of firewood, charcoal, coke and similar fuels",
  "industry_473300": "473300 - Retail sale of kerosene and L.P. gas",
  "industry_474101": "474101 - Retail sale of telecommunications equipment",
  "industry_474102": "474102 - Retail sale of computers and peripheral units",
  "industry_474103": "474103 - Retail sale of computer software",
  "industry_474200": "474200 - Retail sale of audio and video equipment",
  "industry_475101": "475101 - Retail sale of fabrics",
  "industry_475102": "475102 - Retail sale of tailoring accessories and trimming materials",
  "industry_475103": "475103 - Retail sale of knitting yarn",
  "industry_475104": "475104 - Retail sale of embroidery and drawn works",
  "industry_475105": "475105 - Retail sale of household linen",
  "industry_475106": "475106 - Retail sale of drapery (incl. blinds and curtains)",
  "industry_475107": "475107 - Retail sale of rope, cord and netting appliances",
  "industry_475199": "475199 - Retail sale of other textiles or textiles of several kinds",
  "industry_475200": "475200 - Retail sale of hardware, metalware, paints and other building renovation materials",
  "industry_475300": "475300 - Retail sale of carpets, rugs, wall and floor coverings",
  "industry_475901": "475901 - Retail sale of bamboo and cane products (excl. furniture and fixtures)",
  "industry_475902": "475902 - Retail sale of china, earthenware and glassware",
  "industry_475903": "475903 - Retail sale of cooking and kitchen utensils, other than electrical",
  "industry_475904": "475904 - Retail sale of canvas and canvas products",
  "industry_475905": "475905 - Retail sale of electrical goods (excl. machinery, office and telecommunications equipment and appliances, audio and video equipment)",
  "industry_475906": "475906 - Retail sale of furniture and fixtures",
  "industry_475999": "475999 - Retail sale of household articles n.e.c.",
  "industry_476100": "476100 - Retail sale of books, newspapers and stationery",
  "industry_476200": "476200 - Retail sale of music and video recordings",
  "industry_476300": "476300 - Retail sale of sporting equipment",
  "industry_476401": "476401 - Retail sale of toys",
  "industry_476402": "476402 - Retail sale of computer games",
  "industry_476403": "476403 - Retail sale of gambling apparatus",
  "industry_477101": "477101 - Retail sale of footwear and shoe accessories",
  "industry_477102": "477102 - Retail sale of wearing apparel",
  "industry_477103": "477103 - Retail sale of umbrellas",
  "industry_477104": "477104 - Retail sale of luggage cases, handbags and similar articles of leather or leather substitutes",
  "industry_477199": "477199 - Combined retail sale of clothing, footwear and leather articles",
  "industry_477201": "477201 - Retail sale of Chinese drugs and herbs",
  "industry_477202": "477202 - Retail sale of medicines and health supplements (with or without selling cosmetics and personal care products)",
  "industry_477203": "477203 - Retail sale of medical goods",
  "industry_477204": "477204 - Retail sale of cosmetics and personal care products",
  "industry_477301": "477301 - Retail sale of motor vehicles",
  "industry_477302": "477302 - Retail sale of motorcycles",
  "industry_477303": "477303 - Retail sale of motor vehicle and motorcycle parts and accessories",
  "industry_477399": "477399 - Retail sale of other transport equipment (except motor vehicles and motorcycles)",
  "industry_477401": "477401 - Retail sale of works of art and craft",
  "industry_477402": "477402 - Retail sale of jewellery and precious metal accessories",
  "industry_477403": "477403 - Retail sale of imitation jewellery and related articles",
  "industry_477404": "477404 - Optical shops",
  "industry_477405": "477405 - Retail sale of photographic equipment and supplies",
  "industry_477406": "477406 - Retail sale of sacks and bags (excl. handbags and travelling bags)",
  "industry_477407": "477407 - Retail sale of musical instruments",
  "industry_477408": "477408 - Retail sale of watches and clocks",
  "industry_477411": "477411 - Retail sale of paper products",
  "industry_477412": "477412 - Retail sale of Chinese religious articles",
  "industry_477413": "477413 - Retail sale of flowers and plants (incl. seeds, fertilisers and horticultural sundries)",
  "industry_477414": "477414 - Retail sale of pets and animals (incl. feeds and accessories)",
  "industry_477415": "477415 - Retail sale of fire prevention equipment",
  "industry_477416": "477416 - Retail sale of gifts, novelties and souvenirs",
  "industry_477417": "477417 - Luxuries comprehensive stores",
  "industry_477418": "477418 - Retail sale of scientific & professional instruments (excl. medical & dental equipment and appliances)",
  "industry_477421": "477421 - Retail sale of sewing machines and parts (incl. stands)",
  "industry_477422": "477422 - Retail sale of office appliances and equipment (excl. computers, furniture and fixtures)",
  "industry_477499": "477499 - Other miscellaneous retail sale of new goods n.e.c.",
  "industry_477501": "477501 - Retail sale of antiques",
  "industry_477502": "477502 - Stamp collection shops",
  "industry_477599": "477599 - Retail sale of second-hand goods n.e.c.",
  "industry_478101": "478101 - Retail sale of food, beverages and tobacco products via mobile stalls",
  "industry_478102": "478102 - Retail sale of textiles, clothing and footwear via mobile stalls",
  "industry_478199": "478199 - Retail sale of other goods via mobile stalls",
  "industry_478201": "478201 - Retail sale via mail order or internet",
  "industry_478299": "478299 - Other retail sale not via stores and movable stalls",
  "industry_491000": "491000 - Railway and cable transport",
  "industry_492100": "492100 - Public bus services",
  "industry_492201": "492201 - Urban taxi services",
  "industry_492202": "492202 - New Territories taxi services",
  "industry_492203": "492203 - Lantau taxi services",
  "industry_492300": "492300 - Non-scheduled public light bus services",
  "industry_492400": "492400 - Scheduled public light bus services",
  "industry_492500": "492500 - School bus services",
  "industry_492601": "492601 - Rental of passenger vehicles with drivers (providing local transportation services only)",
  "industry_492602": "492602 - Rental of passenger vehicles with drivers (with cross-border transportation services)",
  "industry_492701": "492701 - Transport by goods vehicles (excl. tractors) (providing local transportation services only)",
  "industry_492702": "492702 - Transport by goods vehicles (excl. tractors) (with cross-border transportation services)",
  "industry_492801": "492801 - Transport by tractors (providing local transportation services only)",
  "industry_492802": "492802 - Transport by tractors (with cross-border transportation services)",
  "industry_499000": "499000 - Other land transport services",
  "industry_501100": "501100 - Ship agents and managers",
  "industry_501200": "501200 - Local representative offices of overseas shipping companies",
  "industry_501301": "501301 - Ship owners of sea-going vessels for passenger transport",
  "industry_501302": "501302 - Ship owners of sea-going vessels for freight transport",
  "industry_501401": "501401 - Operators of sea-going vessels for passenger transport",
  "industry_501402": "501402 - Operators of sea-going vessels for freight transport",
  "industry_501501": "501501 - Ship owners and operators of passenger vessels moving between Hong Kong and the ports in Pearl River Delta",
  "industry_501502": "501502 - Ship owners and operators of freight vessels moving between Hong Kong and the ports in Pearl River Delta",
  "industry_502101": "502101 - Licensed and franchised ferry services",
  "industry_502199": "502199 - Kaito and non-scheduled inland water passenger transport",
  "industry_502200": "502200 - Inland freight water transport",
  "industry_510100": "510100 - Hong Kong-based airline and helicopter companies",
  "industry_510201": "510201 - Local representative offices of overseas airline companies (passenger)",
  "industry_510202": "510202 - Local representative offices of overseas airline companies (freight)",
  "industry_510900": "510900 - Air transport services n.e.c.",
  "industry_521100": "521100 - Cold storage",
  "industry_521200": "521200 - General cargo warehouses",
  "industry_522101": "522101 - Car park operation",
  "industry_522102": "522102 - Vehicular tunnel, bridge and highway operators",
  "industry_522103": "522103 - Loading and unloading of luggage or freight during land transport",
  "industry_522199": "522199 - Service activities incidental to land transportation n.e.c.",
  "industry_522201": "522201 - Container terminal and marine cargo terminal operators",
  "industry_522202": "522202 - Mid-stream operation",
  "industry_522203": "522203 - Port facilities operators (except container and marine cargo terminals)",
  "industry_522204": "522204 - Container back-up activities",
  "industry_522299": "522299 - Service activities incidental to water transportation n.e.c.",
  "industry_522300": "522300 - Service activities incidental to air transportation",
  "industry_522901": "522901 - Air cargo forwarding services",
  "industry_522902": "522902 - Sea cargo forwarding services",
  "industry_522903": "522903 - Land cargo forwarding services",
  "industry_522904": "522904 - Packing and crating services",
  "industry_522905": "522905 - Cargo inspection, sampling and weighing services",
  "industry_522906": "522906 - Shipbrokers",
  "industry_522999": "522999 - Other miscellaneous transportation support activities n.e.c.",
  "industry_531000": "531000 - Postal activities",
  "industry_532100": "532100 - International courier activities",
  "industry_532200": "532200 - Local courier activities",
  "industry_550100": "550100 - Hotels",
  "industry_550900": "550900 - Guesthouses, boarding houses and other short term accommodation activities",
  "industry_561101": "561101 - Hong Kong style tea cafes",
  "industry_561103": "561103 - Japanese cuisine restaurants",
  "industry_561104": "561104 - Korean cuisine restaurants",
  "industry_561105": "561105 - Thai cuisine restaurants",
  "industry_561106": "561106 - Vietnamese cuisine restaurants",
  "industry_561107": "561107 - French cuisine restaurants",
  "industry_561108": "561108 - Italian cuisine restaurants",
  "industry_561109": "561109 - Guangdong cuisine restaurants",
  "industry_561110": "561110 - Beijing, Sichuan, Shanghai cuisine restaurants",
  "industry_561111": "561111 - Chinese restaurants serving other Chinese cuisines",
  "industry_561199": "561199 - Restaurants n.e.c.",
  "industry_561200": "561200 - Fast food cafes",
  "industry_561901": "561901 - Other eating places with seats",
  "industry_561902": "561902 - Stalls at food court",
  "industry_561903": "561903 - Takeaway shops and meal outlets without seats",
  "industry_562000": "562000 - Event catering and other food service activities",
  "industry_563100": "563100 - Bars and lounges",
  "industry_563200": "563200 - Coffee shops",
  "industry_563300": "563300 - Herb tea shops",
  "industry_563900": "563900 - Beverage serving places n.e.c.",
  "industry_581100": "581100 - Publishing of books, directories and mailing lists",
  "industry_581201": "581201 - Publishing of newspapers",
  "industry_581202": "581202 - Publishing of magazines and periodicals",
  "industry_581900": "581900 - Other publishing activities",
  "industry_582100": "582100 - Publishing of computer games",
  "industry_582900": "582900 - Publishing of other softwares",
  "industry_591100": "591100 - Motion picture, video and television programme production activities",
  "industry_591200": "591200 - Motion picture, video and television programme post-production activities",
  "industry_591300": "591300 - Motion picture, video and television programme distribution activities",
  "industry_591400": "591400 - Motion picture projection activities",
  "industry_592000": "592000 - Sound recording and music publishing activities",
  "industry_601000": "601000 - Radio broadcasting",
  "industry_602000": "602000 - Television programming and broadcasting activities",
  "industry_611000": "611000 - Telecommunications network operation",
  "industry_619100": "619100 - Internet access services",
  "industry_619900": "619900 - Other miscellaneous telecommunications activities n.e.c.",
  "industry_620101": "620101 - Development of computer games",
  "industry_620199": "620199 - Development of other softwares and programming activities",
  "industry_620200": "620200 - Information technology consultancy activities and computer facilities management activities",
  "industry_620900": "620900 - Other information technology service activities",
  "industry_631100": "631100 - Data processing, hosting and related activities",
  "industry_631200": "631200 - Web portals",
  "industry_639100": "639100 - News agency activities",
  "industry_639900": "639900 - Other information service activities n.e.c.",
  "industry_641100": "641100 - Monetary authorities",
  "industry_641201": "641201 - Licensed banks",
  "industry_641202": "641202 - Restricted licensed banks",
  "industry_641203": "641203 - Deposit-taking companies",
  "industry_641300": "641300 - Local representative offices of foreign banks",
  "industry_642000": "642000 - Investment and holding companies",
  "industry_644000": "644000 - Trusts, funds and similar financial entities",
  "industry_649100": "649100 - Financial leasing",
  "industry_649201": "649201 - Pawnshops",
  "industry_649299": "649299 - Personal loan, mortgage, instalment credit and other credit granting",
  "industry_649901": "649901 - Money changers and foreign exchange brokers or dealers",
  "industry_649999": "649999 - Other miscellaneous financial service activities n.e.c.",
  "industry_651100": "651100 - Life insurance underwriting",
  "industry_651200": "651200 - Non-life insurance underwriting",
  "industry_652000": "652000 - Pension funding",
  "industry_661100": "661100 - Administration of marketplaces for securities and commodity contracts",
  "industry_661201": "661201 - Investment banking activities",
  "industry_661202": "661202 - Securities brokerage",
  "industry_661203": "661203 - Commodity futures and gold bullion brokers and dealers",
  "industry_661901": "661901 - Investment advisory services",
  "industry_661902": "661902 - Trustees and custodians",
  "industry_661999": "661999 - Other miscellaneous activities auxiliary to financial service activities n.e.c.",
  "industry_662100": "662100 - Risk and damage evaluation",
  "industry_662200": "662200 - Activities of insurance agents and brokers",
  "industry_662900": "662900 - Other activities auxiliary to insurance and pension funding",
  "industry_663000": "663000 - Fund management",
  "industry_681100": "681100 - Real estate development",
  "industry_681200": "681200 - Real estate leasing",
  "industry_681300": "681300 - Real estate development with leasing",
  "industry_681400": "681400 - Property holding and resale",
  "industry_682100": "682100 - Real estate brokerage and agency",
  "industry_682200": "682200 - Real estate maintenance management",
  "industry_682900": "682900 - Other real estate services n.e.c.",
  "industry_691100": "691100 - Solicitor services",
  "industry_691200": "691200 - Barrister services",
  "industry_692100": "692100 - Accounting and auditing services",
  "industry_692200": "692200 - Book-keeping and general accounting services",
  "industry_701100": "701100 - Business head offices of local enterprises",
  "industry_701200": "701200 - Head/Regional offices of enterprises operating aboard",
  "industry_702100": "702100 - Public relation services",
  "industry_702200": "702200 - Business management and consultancy services",
  "industry_711100": "711100 - Architectural design services",
  "industry_711200": "711200 - Surveying services related to real estate and construction",
  "industry_711300": "711300 - Structural engineering services",
  "industry_711400": "711400 - Building services engineering services",
  "industry_711500": "711500 - Civil and geotechnical engineering services",
  "industry_711600": "711600 - Environmental engineering services and related consultancy services",
  "industry_711700": "711700 - Town planning and urban design activities",
  "industry_711900": "711900 - Combined and other architectural, surveying and engineering services related to construction",
  "industry_712000": "712000 - Technical testing and analysis",
  "industry_719000": "719000 - Engineering, technical and consultancy services not related to construction and real estate activities n.e.c.",
  "industry_721000": "721000 - Research and development on natural sciences and engineering",
  "industry_722000": "722000 - Research and development on social sciences and humanities",
  "industry_729000": "729000 - General and miscellaneous research and development services",
  "industry_730000": "730000 - Veterinary activities",
  "industry_741100": "741100 - Advertising companies and agencies",
  "industry_741900": "741900 - Advertising services n.e.c.",
  "industry_742000": "742000 - Market research and public opinion polling",
  "industry_751100": "751100 - Interior and furniture design services",
  "industry_751200": "751200 - Multi-media, visual and graphic design activities",
  "industry_751300": "751300 - Fashion design services (incl. accessories)",
  "industry_751400": "751400 - Industrial design services",
  "industry_751900": "751900 - Specialised design activities n.e.c.",
  "industry_752100": "752100 - Photographic production services",
  "industry_752200": "752200 - Photo printing and photo finishing services",
  "industry_753000": "753000 - Translation and interpretation services",
  "industry_759000": "759000 - Other miscellaneous professional, scientific and technical activities n.e.c.",
  "industry_771000": "771000 - Renting and leasing machinery and equipment",
  "industry_772100": "772100 - Renting and leasing of recreational and sports goods",
  "industry_772200": "772200 - Renting of video tapes and discs",
  "industry_772900": "772900 - Renting and leasing of other personal and household goods",
  "industry_773000": "773000 - Leasing of intellectual property and similar non-financial intangible assets (except copyrighted works)",
  "industry_781000": "781000 - Activities of employment placement agencies",
  "industry_782000": "782000 - Provision of temporary personnel",
  "industry_783000": "783000 - Management of human resources functions",
  "industry_791000": "791000 - Travel agency activities",
  "industry_799000": "799000 - Other reservation service and tourist-related activities",
  "industry_801000": "801000 - Security guard services",
  "industry_802000": "802000 - Security system operation services",
  "industry_803000": "803000 - Private detective services",
  "industry_811000": "811000 - Pest control services",
  "industry_812100": "812100 - General cleaning of buildings",
  "industry_812900": "812900 - Other building and industrial cleaning activities",
  "industry_813000": "813000 - Landscape care and greenery services",
  "industry_821100": "821100 - Combined office administrative service activities",
  "industry_821900": "821900 - Photocopying, document preparation and other specialised office support activities",
  "industry_822000": "822000 - Activities of call centres",
  "industry_823000": "823000 - Convention and trade show organising services",
  "industry_829100": "829100 - Debt collecting and credit reporting services",
  "industry_829200": "829200 - Packaging activities",
  "industry_829300": "829300 - Printing agents",
  "industry_829400": "829400 - Agents for artists, athletes, models and other public figures",
  "industry_829900": "829900 - Other miscellaneous business support service activities n.e.c.",
  "industry_841000": "841000 - Government administration; economic and social policy",
  "industry_842000": "842000 - Public order and safety activities",
  "industry_851100": "851100 - Kindergartens",
  "industry_851200": "851200 - Primary schools",
  "industry_852000": "852000 - Secondary schools",
  "industry_853000": "853000 - Universities and colleges providing post-secondary courses",
  "industry_854101": "854101 - Ball games instruction",
  "industry_854102": "854102 - Athletic instruction",
  "industry_854103": "854103 - Swimming and lifeguard instruction",
  "industry_854104": "854104 - Yoga and gymnastics instruction",
  "industry_854105": "854105 - Marital arts and taiji instruction",
  "industry_854106": "854106 - Windsurfing, yachting and rowing instruction",
  "industry_854107": "854107 - Wilderness skills and mountaineering instruction",
  "industry_854108": "854108 - Skating and roller skating instruction",
  "industry_854111": "854111 - Riding instruction",
  "industry_854112": "854112 - General sports skills training",
  "industry_854199": "854199 - Other sports skills instruction",
  "industry_854201": "854201 - Drama instruction",
  "industry_854202": "854202 - Music instruction",
  "industry_854203": "854203 - Dance instruction",
  "industry_854204": "854204 - Painting instruction",
  "industry_854205": "854205 - Sculpture instruction",
  "industry_854206": "854206 - Calligraphy instruction",
  "industry_854207": "854207 - Photography instruction",
  "industry_854208": "854208 - General fine arts and performing arts schools (except academic)",
  "industry_854299": "854299 - Other cultural education",
  "industry_854300": "854300 - Special education",
  "industry_854400": "854400 - Academic tutoring services",
  "industry_854901": "854901 - Automobile driving instruction",
  "industry_854902": "854902 - Computer application training",
  "industry_854903": "854903 - Linguistic instruction",
  "industry_854904": "854904 - Industrial and commercial vocational schools",
  "industry_854905": "854905 - Cookery instruction",
  "industry_854999": "854999 - Other miscellaneous education n.e.c.",
  "industry_855000": "855000 - Educational support services",
  "industry_861100": "861100 - Hospitals",
  "industry_861200": "861200 - Maternity homes",
  "industry_862100": "862100 - Clinics",
  "industry_862200": "862200 - Medical practitioners' offices",
  "industry_862300": "862300 - Dental practitioner activities",
  "industry_869100": "869100 - Medical and X-ray laboratories",
  "industry_869200": "869200 - Allied health personnel practice activities",
  "industry_869300": "869300 - Chinese medicine practitioners",
  "industry_869900": "869900 - Miscellaneous human health services n.e.c.",
  "industry_871100": "871100 - Nursing homes for the elderly",
  "industry_871900": "871900 - Nursing homes n.e.c.",
  "industry_872000": "872000 - Residential care activities for substance abuse",
  "industry_873000": "873000 - Residential care activities for the elderly",
  "industry_874000": "874000 - Residential care activities for persons with disabilities",
  "industry_879000": "879000 - Other residential care activities",
  "industry_881000": "881000 - Social work activities without accommodation for the elderly",
  "industry_882000": "882000 - Social work activities without accommodation for the disabled",
  "industry_883000": "883000 - Youth centres",
  "industry_884000": "884000 - Child day-care centres",
  "industry_885000": "885000 - Welfare foundations and development projects",
  "industry_889000": "889000 - Other social work activities without accommodation",
  "industry_901000": "901000 - Performing arts activities",
  "industry_902000": "902000 - Creative artists, musicians and writers",
  "industry_903000": "903000 - Performing arts venue operation",
  "industry_910100": "910100 - Libraries and archives activities",
  "industry_910200": "910200 - Museums activities and operation of historical sites",
  "industry_910300": "910300 - Botanical and zoological gardens, nature reserves activities",
  "industry_920000": "920000 - Activities of amusement parks and theme parks",
  "industry_931101": "931101 - Billiard centres",
  "industry_931102": "931102 - Bowling centres",
  "industry_931103": "931103 - Swimming pools",
  "industry_931104": "931104 - Skating centres",
  "industry_931105": "931105 - Gymnasium and fitness centres",
  "industry_931106": "931106 - Golf centres",
  "industry_931107": "931107 - Tennis courts",
  "industry_931108": "931108 - Football and athletics pitches",
  "industry_931111": "931111 - General-purposes sports centres",
  "industry_931199": "931199 - Other sports facilities operators n.e.c.",
  "industry_931200": "931200 - Activities of sports clubs",
  "industry_931900": "931900 - Other sports activities",
  "industry_939100": "939100 - Betting activities",
  "industry_939200": "939200 - Night clubs and dance halls",
  "industry_939300": "939300 - Karaoke",
  "industry_939400": "939400 - Discotheques",
  "industry_939500": "939500 - Amusement game centres",
  "industry_939900": "939900 - Other miscellaneous entertainment activities n.e.c.",
  "industry_941100": "941100 - Activities of business and employers membership organisations",
  "industry_941200": "941200 - Activities of professional membership organisations",
  "industry_942000": "942000 - Activities of trade unions",
  "industry_943000": "943000 - Activities of religious organisations",
  "industry_944000": "944000 - Activities of political organisations",
  "industry_949000": "949000 - Activities of other membership organisations n.e.c.",
  "industry_951000": "951000 - Servicing and repairing of motor vehicles and motorcycles",
  "industry_952100": "952100 - Repair of computers and peripheral equipment",
  "industry_952200": "952200 - Repair of communications equipment",
  "industry_953100": "953100 - Repair of audio and visual electronic products",
  "industry_953200": "953200 - Repair of household appliances, home and garden equipment",
  "industry_953300": "953300 - Repair of footwear and leather goods",
  "industry_953400": "953400 - Repair of furniture and home furnishings",
  "industry_953500": "953500 - Locksmith services",
  "industry_953600": "953600 - Repair of watches and clocks",
  "industry_953700": "953700 - Repair of jewellery",
  "industry_953900": "953900 - Repair of other personal and household goods",
  "industry_960100": "960100 - Laundry and dry-cleaning services",
  "industry_960201": "960201 - Hairdressing treatment",
  "industry_960202": "960202 - Made-up, skin and facial care services",
  "industry_960203": "960203 - Weight control and slimming services",
  "industry_960299": "960299 - Other beauty and body prettifying treatment",
  "industry_960300": "960300 - Bathhouse services",
  "industry_960401": "960401 - Body massage services",
  "industry_960402": "960402 - Foot reflexology",
  "industry_960500": "960500 - Geomancy, fortune telling and spiritualist services",
  "industry_960600": "960600 - Match-making, matrimonial agency and marriage ceremony services",
  "industry_960700": "960700 - Care and training services for pets and animals",
  "industry_960800": "960800 - Funeral and related activities",
  "industry_960900": "960900 - Other miscellaneous personal service activities n.e.c.",
  "industry_970000": "970000 - Activities of households as employers of domestic personnel",
  "industry_980000": "980000 - Goods- and services-producing activities of private households for own use",
  "industry_990000": "990000 - Activities of extraterritorial organisations and bodies",
  "industry_OTHER_INSTITUTION": "Other Institution (please specify)",
};
